(function (global) {
  'use strict';

  const seeds = [
  {
    "handle": "maylee-three-drawer-night-stand-dark-brown",
    "productId": "8824518213927",
    "variantId": "47083190845735",
    "sku": "B947-93",
    "family": "Maylee",
    "kind": "storage",
    "label": "Maylee nightstand",
    "width": 33.5,
    "depth": 20,
    "height": 29.75,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/maylee-three-drawer-night-stand-dark-brown?variant=47083190845735",
    "verifiedAt": "2026-09-20T18:37:18.982Z",
    "sourceHeading": "Maylee - Three Drawer Night Stand - Dark Brown",
    "sourceDimensions": "33.5in L, 20.0in W, 29.75in H, and 116.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "maylee-dresser-dark-brown",
    "productId": "8824518607143",
    "variantId": "47083192320295",
    "sku": "B947-31",
    "family": "Maylee",
    "kind": "storage",
    "label": "Maylee dresser",
    "width": 71.38,
    "depth": 20.75,
    "height": 42.63,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/maylee-dresser-dark-brown?variant=47083192320295",
    "verifiedAt": "2026-09-20T18:37:18.975Z",
    "sourceHeading": "Maylee - Dresser - Dark Brown",
    "sourceDimensions": "71.38in L, 20.75in W, 42.63in H, and 262.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "maylee-five-drawer-chest-dark-brown",
    "productId": "8824518508839",
    "variantId": "47083192221991",
    "sku": "B947-46",
    "family": "Maylee",
    "kind": "storage",
    "label": "Maylee 5-drawer chest",
    "width": 43.5,
    "depth": 20.88,
    "height": 54.13,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/maylee-five-drawer-chest-dark-brown?variant=47083192221991",
    "verifiedAt": "2026-09-20T18:37:18.966Z",
    "sourceHeading": "Maylee - Five Drawer Chest - Dark Brown",
    "sourceDimensions": "43.5in L, 20.88in W, 54.13in H, and 205.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "realyn-three-drawer-night-stand-white-brown-beige",
    "productId": "8989040148775",
    "variantId": "47611914354983",
    "sku": "B743-93",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 3-drawer nightstand",
    "width": 27,
    "depth": 17,
    "height": 27.75,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-three-drawer-night-stand-white-brown-beige?variant=47611914354983",
    "verifiedAt": "2026-09-20T18:37:18.967Z",
    "sourceHeading": "Realyn - Three Drawer Night Stand - White / Brown / Beige",
    "sourceDimensions": "27.0in L, 17.0in W, 27.75in H, and 68.34 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "realyn-one-drawer-night-stand-chipped-white",
    "productId": "10339503800615",
    "variantId": "51872619757863",
    "sku": "B743-91",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 1-drawer nightstand",
    "width": 24,
    "depth": 16,
    "height": 27,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-one-drawer-night-stand-chipped-white?variant=51872619757863",
    "verifiedAt": "2026-09-20T18:37:19.128Z",
    "sourceHeading": "Realyn - One Drawer Night Stand - Chipped White",
    "sourceDimensions": "24.0in L, 16.0in W, 27.0in H, and 44.09 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "realyn-dresser-mirror",
    "productId": "9000374862119",
    "variantId": "47754899259687",
    "sku": "B743-31",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 7-drawer dresser",
    "width": 63.88,
    "depth": 18,
    "height": 40.5,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-dresser-mirror?variant=47754899259687",
    "verifiedAt": "2026-09-20T18:37:19.156Z",
    "sourceHeading": "Realyn - Dresser - 7-drawer - White / Brown / Beige",
    "sourceDimensions": "63.88in L, 18.0in W, 40.5in H, and 224.0 lb",
    "expectedOptions": [
      {
        "name": "Color",
        "value": "White"
      },
      {
        "name": "Product Type",
        "value": "Dressers"
      },
      {
        "name": "Storage Option",
        "value": "7 Drawers"
      }
    ]
  },
  {
    "handle": "realyn-dresser-mirror",
    "productId": "9000374862119",
    "variantId": "47754899226919",
    "sku": "B743-21",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 6-drawer dresser",
    "width": 54.13,
    "depth": 17.13,
    "height": 36.13,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-dresser-mirror?variant=47754899226919",
    "verifiedAt": "2026-09-20T18:37:19.156Z",
    "sourceHeading": "Realyn - Dresser - 6-drawer - White / Brown / Beige",
    "sourceDimensions": "54.13in L, 17.13in W, 36.13in H, and 201.0 lb",
    "expectedOptions": [
      {
        "name": "Color",
        "value": "White"
      },
      {
        "name": "Product Type",
        "value": "Dressers"
      },
      {
        "name": "Storage Option",
        "value": "6 Drawers"
      }
    ]
  },
  {
    "handle": "realyn-dresser-mirror",
    "productId": "9000374862119",
    "variantId": "51442903089447",
    "sku": "B743B1",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 7-drawer dresser + mirror",
    "width": 63.88,
    "depth": 18,
    "height": 80,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-dresser-mirror?variant=51442903089447",
    "verifiedAt": "2026-09-20T18:37:19.156Z",
    "sourceHeading": "Realyn - Dresser, Mirror - 7-drawer - Two-tone",
    "sourceDimensions": "63.88in L, 18.0in W, 80.0in H, and 272.0 lb",
    "expectedOptions": [
      {
        "name": "Color",
        "value": "White"
      },
      {
        "name": "Product Type",
        "value": "Dresser & Mirror"
      },
      {
        "name": "Storage Option",
        "value": "7 Drawers"
      }
    ]
  },
  {
    "handle": "realyn-dresser-mirror",
    "productId": "9000374862119",
    "variantId": "51442903122215",
    "sku": "B743B12",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn 6-drawer dresser + mirror",
    "width": 54.13,
    "depth": 17.13,
    "height": 74.25,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-dresser-mirror?variant=51442903122215",
    "verifiedAt": "2026-09-20T18:37:19.156Z",
    "sourceHeading": "Realyn - Dresser, Mirror - 6-drawer - Chipped White",
    "sourceDimensions": "54.13in L, 17.13in W, 74.25in H, and 236.0 lb",
    "expectedOptions": [
      {
        "name": "Color",
        "value": "White"
      },
      {
        "name": "Product Type",
        "value": "Dresser & Mirror"
      },
      {
        "name": "Storage Option",
        "value": "6 Drawers"
      }
    ]
  },
  {
    "handle": "realyn-five-drawer-chest-white-brown-beige",
    "productId": "8989040279847",
    "variantId": "47611914551591",
    "sku": "B743-46",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn tall 5-drawer chest",
    "width": 40.13,
    "depth": 18.13,
    "height": 58.13,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-five-drawer-chest-white-brown-beige?variant=47611914551591",
    "verifiedAt": "2026-09-20T18:37:19.133Z",
    "sourceHeading": "Realyn - Five Drawer Chest - White / Brown / Beige",
    "sourceDimensions": "40.13in L, 18.13in W, 58.13in H, and 211.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "realyn-chipped-white-chest",
    "productId": "8658847629607",
    "variantId": "46664811512103",
    "sku": "B743-45",
    "family": "Realyn",
    "kind": "storage",
    "label": "Realyn compact chest",
    "width": 34,
    "depth": 17,
    "height": 48.25,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-chipped-white-chest?variant=46664811512103",
    "verifiedAt": "2026-09-20T18:37:19.125Z",
    "sourceHeading": "Realyn - Chest - Chipped White",
    "sourceDimensions": "34.0in L, 17.0in W, 48.25in H, and 186.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "brinxton-charcoal-five-drawer-chest",
    "productId": "8659938541863",
    "variantId": "46667198333223",
    "sku": "B249-46",
    "family": "Brinxton",
    "kind": "storage",
    "label": "Brinxton 5-drawer chest",
    "width": 33.86,
    "depth": 15.63,
    "height": 54.21,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/brinxton-charcoal-five-drawer-chest?variant=46667198333223",
    "verifiedAt": "2026-09-20T18:37:19.336Z",
    "sourceHeading": "Brinxton - Five Drawer Chest - Charcoal",
    "sourceDimensions": "33.86\"W x 15.63\"D x 54.21\"H - 155.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "brinxton-charcoal-two-drawer-night-stand",
    "productId": "8659940737319",
    "variantId": "46667202593063",
    "sku": "B249-92",
    "family": "Brinxton",
    "kind": "storage",
    "label": "Brinxton 2-drawer nightstand",
    "width": 23.82,
    "depth": 15.55,
    "height": 29.45,
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/brinxton-charcoal-two-drawer-night-stand?variant=46667202593063",
    "verifiedAt": "2026-09-20T18:37:19.305Z",
    "sourceHeading": "Brinxton - Two Drawer Night Stand - Charcoal",
    "sourceDimensions": "23.82\"W x 15.55\"D x 29.45\"H - 62.0 lb",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "willarae-taupe-queen-sofa-sleeper",
    "family": "Willarae",
    "kind": "sofa",
    "label": "Willarae sofa sleeper (closed)",
    "width": 92,
    "depth": 40,
    "height": 40,
    "sourceHeading": "Willarae - Queen Sofa Sleeper - Taupe",
    "clearanceNote": "Closed sofa footprint only. The open sleeper needs additional space; confirm its extended dimensions before ordering.",
    "productId": "9817622315303",
    "variantId": "49980984721703",
    "sku": "5980339",
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/willarae-taupe-queen-sofa-sleeper?variant=49980984721703",
    "verifiedAt": "2026-09-20T18:37:19.381Z",
    "sourceDimensions": "92.0in L, 40.0in W, 40.0in H",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  },
  {
    "handle": "realyn-chipped-white-twin-day-bed-with-storage",
    "family": "Realyn",
    "kind": "bed",
    "label": "Realyn twin daybed (drawers closed)",
    "width": 79.25,
    "depth": 44.5,
    "height": 56,
    "sourceHeading": "Realyn - Twin Day Bed - Chipped White",
    "dimensionFormat": "table",
    "clearanceNote": "Daybed footprint with drawers closed. Allow additional space to open the storage drawers; mattress is sold separately.",
    "productId": "8658693783847",
    "variantId": "46664184234279",
    "sku": "B743/80/60",
    "unit": "inches",
    "shape": "rect",
    "sourceURL": "https://5thdetroit.com/products/realyn-chipped-white-twin-day-bed-with-storage?variant=46664184234279",
    "verifiedAt": "2026-09-20T18:37:19.361Z",
    "sourceDimensions": "79.25\"W x 44.5\"D x 56\"H",
    "expectedOptions": [
      {
        "name": "Title",
        "value": "Default Title"
      }
    ]
  }
];
  const byVariant = new Map(seeds.map(seed => [seed.variantId, seed]));
  const normalID = value => String(value == null ? '' : value);
  const safeHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);

  function measurementMatches(product, seed) {
    const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
    const blockPattern = seed.dimensionFormat === 'table' ? /<h4>\s*<b>([^<]+)<\/b>\s*<\/h4>\s*<table\b[^>]*>([\s\S]*?)<\/table>/gi : /<b>([^<]+)<\/b>\s*<br\s*\/?>\s*([^<]+)/gi;
    const blocks = Array.from(String(product.description || '').matchAll(blockPattern)).filter(block => clean(block[1]) === seed.sourceHeading);
    if (blocks.length !== 1) return false;
    const dimensions = blocks[0][2].match(/([\d.]+)in L,\s*([\d.]+)in W,\s*([\d.]+)in H/i) || blocks[0][2].match(/([\d.]+)\s*["″]W\s*x\s*([\d.]+)\s*["″]D\s*x\s*([\d.]+)\s*["″]H/i);
    return !!dimensions && [seed.width, seed.depth, seed.height].every((value, index) => Math.abs(Number(dimensions[index + 1]) - value) < 0.001);
  }

  function verifyProduct(product, seed) {
    if (!product || !seed || normalID(product.id) !== seed.productId || product.handle !== seed.handle || !Array.isArray(product.variants)) return null;
    const variant = product.variants.find(value => normalID(value.id) === seed.variantId);
    if (!variant || variant.sku !== seed.sku || typeof variant.available !== 'boolean' || !Number.isSafeInteger(variant.price) || variant.price < 0) return null;
    if (!seed.expectedOptions.every(expected => {
      const index = (product.options || []).findIndex(option => (typeof option === 'string' ? option : option.name) === expected.name);
      return index >= 0 && (variant.options && variant.options[index] != null ? variant.options[index] : variant['option' + (index + 1)]) === expected.value;
    }) || !measurementMatches(product, seed)) return null;
    return variant;
  }

  function exactSeed(item) {
    const identity = item && item.product;
    const seed = identity && byVariant.get(normalID(identity.variantId));
    return seed && item.source === 'catalog' && item.kind === seed.kind && item.shape === 'rect' && item.width === seed.width && item.depth === seed.depth && identity.handle === seed.handle && normalID(identity.productId) === seed.productId && identity.sku === seed.sku ? seed : null;
  }

  function safeImage(product, variant) {
    const candidate = variant.featured_image || product.featured_image;
    const value = typeof candidate === 'string' ? candidate : candidate && (candidate.src || candidate.url);
    if (!value) return '';
    try {
      const url = new URL(value, 'https://5thdetroit.com');
      if (url.protocol !== 'https:' || !['cdn.shopify.com', '5thdetroit.com', 'www.5thdetroit.com'].includes(url.hostname)) return '';
      url.searchParams.set('width', '400');
      return url.href;
    } catch (_) { return ''; }
  }

  function mount(root) {
    if (root.fafPlannerCatalog || !root.fafPlanner) return;
    const panel = root.querySelector('[data-planner-catalog], [data-faf-catalog]');
    if (!panel) return;
    const state = new Map();
    const cards = new Map();
    const requests = new Map();
    const cache = new Map();
    const generations = new Map();
    let requestSequence = 0;
    let active = 0;
    const queue = [];
    let disposed = false;
    const subscriptions = new AbortController();
    const controllers = new Set();
    const route = global.Shopify && global.Shopify.routes && global.Shopify.routes.root || '/';
    const productPath = (seed, json) => route + 'products/' + seed.handle + (json ? '.js' : '?variant=' + encodeURIComponent(seed.variantId));
    const currency = () => global.Shopify && global.Shopify.currency && global.Shopify.currency.active || root.dataset.currency || 'USD';

    function element(tag, className, content) {
      const value = document.createElement(tag);
      if (className) value.className = className;
      if (content != null) value.textContent = content;
      return value;
    }

    const intro = element('p', 'faf-rp__catalog-intro', 'Explore ' + seeds.length + ' measured furniture options. Each option uses its own product dimensions; choose the exact piece shown.');
    const toolbar = element('div', 'faf-rp__catalog-toolbar');
    const searchLabel = element('label', '', 'Search measured pieces');
    const search = element('input');
    search.type = 'search';
    search.placeholder = 'Sofa, daybed, dresser, nightstand…';
    search.autocomplete = 'off';
    searchLabel.append(search);
    const collectionLabel = element('label', '', 'Collection');
    const collection = element('select');
    ['All collections', ...new Set(seeds.map(seed => seed.family))].forEach((name, index) => {
      const option = element('option', '', name);
      option.value = index ? name : '';
      collection.append(option);
    });
    collectionLabel.append(collection);
    toolbar.append(searchLabel, collectionLabel);
    const status = element('p', 'faf-rp__catalog-status', 'Loading current product details…');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    const grid = element('div', 'faf-rp__catalog-grid');
    const empty = element('p', 'faf-rp__catalog-empty', 'No measured pieces match. Try a collection name, sofa, daybed, dresser or nightstand.');
    empty.hidden = true;
    const refresh = element('button', 'faf-planner__btn faf-planner__btn--small faf-rp__catalog-refresh', 'Refresh product details');
    refresh.type = 'button';
    const footer = element('p', 'faf-rp__catalog-note', 'Adding a piece places it in your drawing. Prices and availability are checked again before placement. Taxes and delivery are extra. ');
    const browse = element('a', '', 'Browse all furniture');
    browse.href = route + 'collections/all';
    browse.target = '_blank';
    browse.rel = 'noopener';
    footer.append(browse);
    panel.replaceChildren(intro, toolbar, status, grid, empty, refresh, footer);

    function announce(message) { if (!disposed) status.textContent = message; }
    function emit() {
      if (disposed) return;
      root.dispatchEvent(new CustomEvent('faf:planner-catalog-updated', { bubbles: true, detail: { products: Object.fromEntries(state) } }));
    }
    function formatPrice(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency() }).format(cents / 100); }
      catch (_) { return 'View current price'; }
    }

    function pump() {
      while (active < 4 && queue.length && !disposed) {
        active += 1;
        const job = queue.shift();
        const controller = new AbortController();
        controllers.add(controller);
        const timer = setTimeout(() => controller.abort(), 12000);
        fetch(job.url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } })
          .then(response => { if (!response.ok) throw new Error('Product details could not be loaded.'); return response.json(); })
          .then(product => {
            const previous = cache.get(job.handle);
            if (!previous || job.sequence >= previous.sequence) cache.set(job.handle, { product, at: Date.now(), sequence: job.sequence });
            job.resolve(product);
          }, job.reject)
          .finally(() => { clearTimeout(timer); controllers.delete(controller); active -= 1; pump(); });
      }
    }

    function loadProduct(seed, fresh) {
      if (!safeHandle(seed.handle) || disposed) return Promise.reject(new Error('Product details are unavailable.'));
      const cached = cache.get(seed.handle);
      if (!fresh && cached && Date.now() - cached.at < 60000) return Promise.resolve(cached.product);
      const key = seed.handle + (fresh ? ':fresh' : ':browse');
      if (requests.has(key)) return requests.get(key);
      const task = new Promise((resolve, reject) => { queue.push({ handle: seed.handle, url: productPath(seed, true), sequence: ++requestSequence, resolve, reject }); pump(); });
      requests.set(key, task);
      task.finally(() => requests.delete(key)).catch(() => {});
      return task;
    }

    function setFailure(seed, message) {
      state.set(seed.variantId, { variantId: seed.variantId, title: seed.label, available: false, verified: false, url: productPath(seed), error: message });
      renderCard(seed);
      emit();
    }

    async function update(seed, fresh) {
      const generation = (generations.get(seed.variantId) || 0) + 1;
      generations.set(seed.variantId, generation);
      try {
        const product = await loadProduct(seed, fresh);
        const variant = verifyProduct(product, seed);
        if (!variant) throw new Error('This exact product option could not be verified. View its product details.');
        const record = {
          handle: seed.handle, productId: seed.productId, variantId: seed.variantId, sku: seed.sku,
          title: seed.label, optionTitle: variant.title, available: variant.available, verified: true,
          price: variant.price, priceFormatted: formatPrice(variant.price), currency: currency(),
          image: safeImage(product, variant), url: productPath(seed), checkedAt: new Date().toISOString(), clearanceNote: seed.clearanceNote || ''
        };
        if (generations.get(seed.variantId) === generation) {
          state.set(seed.variantId, record);
          renderCard(seed);
          emit();
        }
        return record;
      } catch (error) {
        if (generations.get(seed.variantId) === generation) setFailure(seed, error.name === 'AbortError' ? 'Product details timed out. Try refreshing.' : error.message);
        return null;
      }
    }

    function renderCard(seed) {
      const card = cards.get(seed.variantId);
      if (!card) return;
      const record = state.get(seed.variantId);
      card.price.textContent = record && record.verified ? record.priceFormatted : record ? 'Price unavailable' : 'Loading price…';
      card.availability.textContent = record ? record.error || (record.available ? 'Available to order' : 'Currently unavailable') : 'Checking availability…';
      card.add.disabled = card.busy || !record || !record.verified || !record.available;
      card.add.textContent = card.busy ? 'Checking…' : 'Add to room';
      if (record && record.image) {
        card.image.hidden = false;
        if (card.image.getAttribute('src') !== record.image) card.image.src = record.image;
      }
    }

    seeds.forEach(seed => {
      const article = element('article', 'faf-rp__catalog-card');
      article.dataset.variantId = seed.variantId;
      const image = element('img', 'faf-rp__catalog-image');
      image.alt = seed.label;
      image.width = 240;
      image.height = 180;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.hidden = true;
      image.addEventListener('error', () => { image.hidden = true; }, { signal: subscriptions.signal });
      const info = element('div', 'faf-rp__catalog-info');
      const title = element('h3', 'faf-rp__catalog-title', seed.label);
      const dimensions = element('p', 'faf-rp__catalog-dimensions', seed.width + '″ W × ' + seed.depth + '″ D');
      const basis = element('p', 'faf-rp__catalog-basis', 'Catalog measurement · ' + seed.sku);
      const price = element('p', 'faf-rp__catalog-price', 'Loading price…');
      const availability = element('p', 'faf-rp__catalog-availability', 'Checking availability…');
      const actions = element('div', 'faf-rp__catalog-actions');
      const add = element('button', 'faf-planner__btn faf-planner__btn--primary faf-planner__btn--small', 'Add to room');
      add.type = 'button';
      add.disabled = true;
      add.setAttribute('aria-label', 'Add ' + seed.label + ' to room');
      const link = element('a', '', 'Product details');
      link.href = productPath(seed);
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'View ' + seed.label + ' product details (opens a new tab)');
      actions.append(add, link);
      info.append(title, dimensions, basis, price, availability, actions);
      if (seed.clearanceNote) info.insertBefore(element('p', 'faf-rp__catalog-note', seed.clearanceNote), actions);
      article.append(image, info);
      grid.append(article);
      const card = { article, image, price, availability, add, busy: false };
      cards.set(seed.variantId, card);
      add.addEventListener('click', async () => {
        if (card.busy || disposed) return;
        card.busy = true;
        renderCard(seed);
        announce('Checking ' + seed.label + '…');
        try {
          const record = await update(seed, true);
          if (disposed || !root.isConnected) return;
          if (!record || !record.available) { announce('This piece cannot be added right now. Your room is unchanged.'); return; }
          const result = await root.fafPlanner.addItem({
            label: seed.label, kind: seed.kind, shape: 'rect', width: seed.width, depth: seed.depth,
            source: 'catalog', product: { handle: seed.handle, productId: seed.productId, variantId: seed.variantId, sku: seed.sku }
          });
          if (!result || result.ok === false) throw new Error('This piece could not be placed. Check the room size and item limit.');
          announce(seed.label + ' added to your room.' + (seed.clearanceNote ? ' ' + seed.clearanceNote : ''));
        } catch (error) { announce(error.message || 'This piece could not be placed. Please try again.'); }
        finally { card.busy = false; renderCard(seed); }
      }, { signal: subscriptions.signal });
    });

    function filter() {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      seeds.forEach(seed => {
        const match = (!collection.value || collection.value === seed.family) && (!query || (seed.label + ' ' + seed.sku + ' ' + seed.kind).toLowerCase().includes(query));
        cards.get(seed.variantId).article.hidden = !match;
        if (match) visible += 1;
      });
      empty.hidden = visible > 0;
      announce(visible + ' measured ' + (visible === 1 ? 'piece' : 'pieces') + ' shown.');
    }

    async function refreshAll() {
      refresh.disabled = true;
      announce('Refreshing current prices and availability…');
      const results = await Promise.all(seeds.map(seed => update(seed, true)));
      refresh.disabled = false;
      const failed = results.filter(value => !value).length;
      announce(failed ? failed + ' product ' + (failed === 1 ? 'option could' : 'options could') + ' not be loaded. Your room is saved; refresh to try again.' : 'Current prices and availability loaded. Choose a measured piece to add to your room.');
      return results;
    }

    async function refreshItem(item) {
      const seed = exactSeed(item);
      return seed ? update(seed, true) : null;
    }
    async function refreshPlan() {
      const plan = root.fafPlanner.getPlan();
      const selected = [...new Map((plan.items || []).map(item => { const seed = exactSeed(item); return [seed && seed.variantId, seed]; }).filter(entry => entry[1])).values()];
      return Promise.all(selected.map(seed => update(seed, true)));
    }
    root.fafPlannerCatalog = {
      getProduct: (variantId, item) => item && (!exactSeed(item) || normalID(item.product.variantId) !== normalID(variantId)) ? null : state.get(normalID(variantId)) || null,
      isVerifiedItem: item => !!exactSeed(item),
      refreshItem, refreshPlan, refresh: refreshAll,
      destroy: () => { disposed = true; subscriptions.abort(); controllers.forEach(controller => controller.abort()); queue.splice(0).forEach(job => job.reject(new Error('Planner closed.'))); delete root.fafPlannerCatalog; }
    };
    search.addEventListener('input', filter, { signal: subscriptions.signal });
    collection.addEventListener('change', filter, { signal: subscriptions.signal });
    refresh.addEventListener('click', () => { refreshAll(); }, { signal: subscriptions.signal });
    root.addEventListener('faf:planner-change', () => {
      const plan = root.fafPlanner.getPlan();
      (plan.items || []).forEach(item => { const seed = exactSeed(item); if (seed && !state.has(seed.variantId)) update(seed, false); });
    }, { signal: subscriptions.signal });
    Promise.all(seeds.map(seed => update(seed, false))).then(results => {
      const failed = results.filter(value => !value).length;
      announce(failed ? 'Some product details could not be loaded. Refresh to try again.' : 'Current prices and availability loaded. Choose a measured piece to add to your room.');
    });
  }

  if (typeof module === 'object' && module.exports) module.exports = { seeds, verifyProduct, exactSeed, safeImage, measurementMatches };
  if (typeof document === 'undefined') return;
  const scan = parent => {
    if (parent.matches && parent.matches('[data-faf-room-planner]')) mount(parent);
    parent.querySelectorAll('[data-faf-room-planner]').forEach(mount);
  };
  ['faf:planner-ready', 'faf:planner:ready'].forEach(eventName => document.addEventListener(eventName, event => {
    const root = event.target.closest && event.target.closest('[data-faf-room-planner]');
    if (root) mount(root);
  }));
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-faf-room-planner]').forEach(root => root.fafPlannerCatalog && root.fafPlannerCatalog.destroy()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})(typeof window === 'undefined' ? globalThis : window);
